import React, { Component } from 'react'

import Title from '../common/title'
import AriaMessage from '../common/ariaMessage'
import Privacy from '../common/privacy'
import Controls from '../common/controls'
import RadioGroup from '../common/radioGroup'
import RadioButton from '../common/radioButton'
import ReactPlayer from 'react-player'

class Welcome1 extends Component {
  constructor(props) {
    super(props)
    this.props.updateActivePage(1)

    this.state = {
      input: { nextStep: { value: '', type: 'radio' }},
      submitClick: false 
    }

    this.focusElements = {}

    for (let name in this.state.input) {
      this.focusElements[name] = React.createRef()
    }

    this.next = this._next.bind(this)
    this.verificationError = this._verificationError.bind(this)
    this.displayErrors = this._displayErrors.bind(this)
  }

  handleChange(name, value) {
    this.handleStateChange(name, value)
  }

  handleStateChange(name, value) {
    this.setState({ 
      input: { ...this.state.input,
        [name]: {...this.state.input[name], 
          value: value 
        }
      }
    })
  }

  _next(e) {
    e.preventDefault()
    this.setState({ submitClick: true })
    for (let property in this.state.input) {
      if (!this.isValid(property)) {
        this.focusElements[property].focus()
        return
      }
    }
    return this.props.next(this.props.match.path, this.state)
  }

  isEmpty(name) {
    if(this.state.input[name].value === '') return true
    return false
  }

  isValid(name) {
    return !this.isEmpty(name)
  }

  _verificationError() {
    let errorText = ""
    if (this.props.verError) {
      errorText = "The values entered do not match our records. Please review your entry or call Client Care at 1-888-639-8181."
    }
    return (
      <div aria-live="polite" className="error">{errorText}</div>
    )
  }

  _displayErrors(name) {
    if (this.state.submitClick) {
      if (!this.isValid(name) && this.isEmpty(name)) {
        return (
          <div id="welcome_p1_ready_error" className="error">This field is required.</div>
        )
      } else if (!this.isValid(name)) {
        return (
          <div id="welcome_p1_ready_error" className="error">Invalid input.</div>
        )
      }
    }
    return (
      <div id="welcome_p1_ready_error" className="error"></div>
    )
  }

  makeRef(name, ref) {
    this.focusElements[name] = ref
  }

  displayNextSteps() {
    const style = this.state.input.nextStep.value === 'ready' ? "block" : "none"
    if (this.props.displayGenetics) {
      return(
        <div id="welcome_p1_next_steps" style={{ display: style }}>
          <div className="welcome-list"role="list">
            <div className="number-circle-wrapper" role="listitem">
              <div className="number-circle">1</div>
              <span>Learn more about the genetic test and provide consent.</span>
            </div>
            <div className="number-circle-wrapper" role="listitem">
              <div className="number-circle">2</div>
              <span>Take the Personality Questionnaire and book your first coaching call.</span>
            </div>
            <div className="number-circle-wrapper" role="listitem">
              <div className="number-circle">3</div>
              <span>Complete your Personal Profile to receive your Welcome Kit.</span>
            </div>
          </div>
          <span className="ready" >Ready? Let's get you matched with your Inspirator!</span>
        </div>
      )
    } else {
      return(
        <div id="welcome_p1_next_steps" style={{ display: style }}>
          <div className="welcome-list"role="list">
            <div className="number-circle-wrapper" role="listitem">
              <div className="number-circle">1</div>
              <span>Take the Personality Questionnaire and book your first coaching call.</span>
            </div>
            <div className="number-circle-wrapper" role="listitem">
              <div className="number-circle">2</div>
              <span>Complete your Personal Profile to receive your Welcome Kit.</span>
            </div>
          </div>
          <span className="ready" >Ready? Let's get you matched with your Inspirator!</span>
        </div>
      )
    }
  }

  displayVideo() {
    if (this.props.welcomeVideo) {
      return(
        <div>
          <h3 className="watch-video">Watch this video to find out what you can expect from Newtopia.</h3>
          <ReactPlayer 
            url={this.props.welcomeVideo} 
            className="video-container"
          />
        </div>
      )
    }
    return
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
  }

  render() {
    const acceptDescribedby = this.state.input.nextStep.value === 'ready' ? "welcome_p1_next_steps" : "welcome_p1_ready_error"
    const acceptLabel = 'Yes, I am! Tell me what happens next.'
    const declineLabel = 'I’m not ready to commit to the program at this time.'
    const displayNextSteps = this.displayNextSteps()
    const displayVideo = this.displayVideo()
    return (
      <div id="welcome_p1">
        <AriaMessage message="Navigated to welcome page" />
        <Title>Welcome to Newtopia</Title>
        <div className="container">
          <h2>Get started!</h2>
          {displayVideo}
          <div className="form-input">
            <h4 id="welcome_p1_ready_text" className="ready-next-steps">Are you ready for the next step?</h4>
            <RadioGroup 
              name="nextStep" 
              initial={this.state.input.nextStep} 
              className="welcome-radio-group" 
              radioRef={this.makeRef.bind(this, "nextStep")} 
              onChange={this.handleChange.bind(this, "nextStep")} 
              ariaLabelledby="welcome_p1_ready_text" 
              ariaDescribedby={acceptDescribedby}
              dataAtId="welcome_p1_isReady"
            >      
              <RadioButton value="ready" label={acceptLabel} /> 
              <RadioButton value="decline" label={declineLabel} />
            </RadioGroup>
            {this.displayErrors("nextStep")}
          </div>
          {displayNextSteps}
          {this.verificationError()}
          <Privacy />
          <Controls dataAtId="welcome_p1" next={this.next} />
        </div>
      </div>
    )
  }
}

export default Welcome1